import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "titleCasewithAvoidWords",
})
export class TitleCasewithAvoidWordsPipe implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || value == "") return value;
    const words = value.split(" ");
    const transformedWords = words.map((word) => {
      //console.log(word);
      
      if (word === "II") {
        return word;
      } else if (word.toLocaleLowerCase() === "and") {
        return word.toLocaleLowerCase();
      } else if (
        word.toLocaleLowerCase() === "cctv" ||
        word.toLocaleLowerCase() === "apartment ada upgrades"
      ) {
        return word.toLocaleUpperCase();
      } else if (word.toLocaleLowerCase().indexOf("-") !== -1) {
        const splitedWords = word.split("-");
        let returnword = "";
        splitedWords.forEach((x) => {
          returnword += x.charAt(0).toUpperCase() + x.slice(1).toLowerCase() + "-";
        });
        return returnword.slice(0, -1);
      } else if (word.toLocaleLowerCase().indexOf("(") !== -1) {
        const splitedWords = word.split("(");
        let returnword = "";
        splitedWords.forEach((x) => {
          returnword += x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
        });
        return "(" + returnword;
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    });

    return transformedWords.join(" ");
  }
}
